import {useSelector} from 'react-redux'

import {getBrandProperties} from '../modules/selectors'

/**
 * A helper hook to get the most commonly used brand properties from the store.
 */
export const useBrand = () => useSelector(getBrandProperties)
